import { __decorate } from "tslib";
import { Action, Getter, Mutation, State } from "@/types";
import { service } from "@/services";
export class PassMethodsModule {
    constructor() {
        this.passMethods = [];
        this.count = 0;
        this.axiosError = null;
    }
    setData(passMethods) {
        this.passMethods = passMethods;
    }
    setTotal(count) {
        this.count = count;
    }
    setError(error) {
        this.axiosError = error;
    }
    get list() {
        return this.passMethods;
    }
    get total() {
        return this.count;
    }
    get errorList() {
        return this.axiosError;
    }
    async get(options) {
        try {
            const data = await service.passMethods.get(options);
            this.setData(data.items);
            this.setTotal(data.total);
        }
        catch (error) {
            this.setError(error);
        }
    }
}
__decorate([
    State()
], PassMethodsModule.prototype, "passMethods", void 0);
__decorate([
    State()
], PassMethodsModule.prototype, "count", void 0);
__decorate([
    State()
], PassMethodsModule.prototype, "axiosError", void 0);
__decorate([
    Mutation()
], PassMethodsModule.prototype, "setData", null);
__decorate([
    Mutation()
], PassMethodsModule.prototype, "setTotal", null);
__decorate([
    Mutation()
], PassMethodsModule.prototype, "setError", null);
__decorate([
    Getter()
], PassMethodsModule.prototype, "list", null);
__decorate([
    Getter()
], PassMethodsModule.prototype, "total", null);
__decorate([
    Getter()
], PassMethodsModule.prototype, "errorList", null);
__decorate([
    Action()
], PassMethodsModule.prototype, "get", null);
